import React from 'react';
import { useInView } from 'react-intersection-observer';
import { useTranslation } from 'react-i18next';
import { FaBriefcase, FaGraduationCap } from 'react-icons/fa';
import './Experience.css';

const Experience = () => {
  const { t } = useTranslation();
  const [ref, inView] = useInView({ threshold: 0.1, triggerOnce: true });

  const workExperiences = [
    {
      title: t('experience.ford.title'),
      company: t('experience.ford.company'),
      location: t('experience.ford.location'),
      period: t('experience.ford.period'),
      description: t('experience.ford.description')
    },
    {
      title: t('experience.wallia.title'),
      company: t('experience.wallia.company'),
      location: t('experience.wallia.location'),
      period: t('experience.wallia.period'),
      description: t('experience.wallia.description')
    },
    {
      title: t('experience.iberostar.title'),
      company: t('experience.iberostar.company'),
      location: t('experience.iberostar.location'),
      period: t('experience.iberostar.period'),
      description: t('experience.iberostar.description')
    },
    {
      title: t('experience.freelance.title'),
      company: t('experience.freelance.company'),
      location: t('experience.freelance.location'),
      period: t('experience.freelance.period'),
      description: t('experience.freelance.description')
    }
  ];

  const educationExperiences = [
    {
      title: t('experience.engineering.title'),
      company: t('experience.engineering.company'),
      period: t('experience.engineering.period'),
      description: t('experience.engineering.description')
    },
    {
      title: t('experience.technician.title'),
      company: t('experience.technician.company'),
      period: t('experience.technician.period'),
      description: t('experience.technician.description')
    }
  ];

  return (
    <section id="experience" className="section experience">
      <div className="container">
        <h2 className="section-title">{t('experience.title')}</h2>
        
        <div ref={ref} className="experience-columns">
          <div className="experience-column">
            <div className="column-header">
              <FaBriefcase className="column-icon" aria-hidden="true" />
              <h3 className="column-title">{t('experience.work', 'Experiencia Laboral')}</h3>
            </div>
            <div className="timeline">
              {workExperiences.map((exp, index) => (
                <div key={index} className={`timeline-item ${inView ? 'fade-in' : ''}`} style={{ animationDelay: `${index * 0.2}s` }}>
                  <div className="timeline-marker"><FaBriefcase size={16} aria-hidden="true" /></div>
                  <div className="timeline-content">
                    <h3>{exp.title}</h3>
                    <h4>{exp.company}</h4>
                    {exp.location && <span className="location">{exp.location}</span>}
                    <span className="period">{exp.period}</span>
                    <div className="exp-description">{exp.description}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="experience-column">
            <div className="column-header">
              <FaGraduationCap className="column-icon" aria-hidden="true" />
              <h3 className="column-title">{t('experience.education', 'Educación')}</h3>
            </div>
            <div className="timeline">
              {educationExperiences.map((exp, index) => (
                <div key={index} className={`timeline-item ${inView ? 'fade-in' : ''}`} style={{ animationDelay: `${(index + 4) * 0.2}s` }}>
                  <div className="timeline-marker"><FaGraduationCap size={16} aria-hidden="true" /></div>
                  <div className="timeline-content">
                    <h3>{exp.title}</h3>
                    <h4>{exp.company}</h4>
                    <span className="period">{exp.period}</span>
                    <div className="exp-description">{exp.description}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;